// index.js
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const requireContext = require.context('./modules', false, /.*\.js$/);

const modules = requireContext.keys().reduce((acc, file) => {
  const moduleName = file.replace(/(^.\/)|(\.js$)/g, '');
  const module = requireContext(file).default;

  if (module.namespaced === undefined) {
    module.namespaced = true;
  }

  return { ...acc, [moduleName]: module };
}, {});

const store = createStore({
  modules,
  plugins: [
    createPersistedState({
      paths: ['auth'], // Only persist the 'auth' module, adjust as needed
      rehydrated: (store) => {
        // Called after state is restored
        console.log('State rehydrated:', store.state);
      },
    }),
  ],
});

export default store;